"use client"

import React, { useLayoutEffect, useRef } from "react"
import { usePathname } from "next/navigation"
import { useGlobalSlideoverStore } from "@/stores/use-global-slideover-store"
import { Slideover } from "@ui/slideover"

export default function GlobalSlideover() {
  const { isOpen, content, closeSlideover, headerTitle, size, rightHeaderContent, canGoBack, popSlideover } =
    useGlobalSlideoverStore()
  const pathname = usePathname()
  const previousPathname = useRef(pathname)

  useLayoutEffect(() => {
    if (previousPathname.current === pathname) return
    previousPathname.current = pathname
    if (useGlobalSlideoverStore.getState().isOpen) closeSlideover()
  }, [pathname, closeSlideover])

  return (
    <Slideover
      open={isOpen}
      onOpenChange={closeSlideover}
      title={headerTitle}
      size={size}
      rightHeaderContent={rightHeaderContent}
      onBack={canGoBack ? popSlideover : undefined}
    >
      {content}
    </Slideover>
  )
}
